import MicroModal from 'micromodal'

MicroModal.init({
	onShow: modal => {
		const iframe = modal.getElementsByTagName('iframe')

		Array.from(iframe).forEach(item => {
			if (item.dataset.source && !item.getAttribute('src')) {
				item.setAttribute('src', item.dataset.source)
			}
		})
	},
	onClose: (modal, element, event) => {
		// @link https://github.com/ghosh/Micromodal/issues/324
		if (event) {
			event.preventDefault()
			event.stopPropagation()
		}
	},
	disableScroll: true,
})
